export default __webpack_public_path__ + "static/media/H'Wear Back Arch.bb61bb80.jpg";